"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _SimpleDate = require("../../core/SimpleDate");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _Styles = require("../../utils/Styles");

var _H = _interopRequireDefault(require("../../elements/headings/H5"));

var _colors = require("HubStyleTokens/colors");

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _lazyEval = _interopRequireDefault(require("../../utils/lazyEval"));

var _UITooltip = _interopRequireDefault(require("../../tooltip/UITooltip"));

var _createLazyPropType = _interopRequireDefault(require("../../utils/propTypes/createLazyPropType"));

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  height: 30px;\n  padding: 0;\n  cursor: ", ";\n  color: ", ";\n  background-color: ", ";\n  ", ";\n\n  ", ";\n\n  ", "\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ::after {\n    content: ' ';\n    display: inline-block;\n    position: absolute;\n    top: 12px;\n    bottom: 0;\n    left: 2px;\n    right: 13px;\n    border-top: 1px solid currentColor;\n    transform: rotate(45deg);\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ::before {\n    content: ' ';\n    display: inline-block;\n    position: absolute;\n    border: 2.5px solid currentColor;\n    border-radius: 50%;\n    top: 22px;\n    left: 16px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 7px 0;\n  color: ", ";\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  text-align: center;\n  font-size: 15px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  margin: 0 auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  height: 42px;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  cursor: default;\n  width: 260px;\n  height: 260px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * Moves values from the start of the array to the end.
 * @param {Array} arr
 * @param {Number} offset
 * @returns {Array}
 */
var rotateArrayBy = function rotateArrayBy(arr, offset) {
  var arrCopy = arr.slice();

  for (var i = 0; i < offset; i++) {
    var firstValue = arrCopy.shift();
    arrCopy.push(firstValue);
  }

  return arrCopy;
};
/**
 * Wrapper for the `SimpleDate` constructor that provides fallover if `month` is outside of the
 * valid range (0 - 11), using the native `Date` API.
 */


var safeSimpleDate = function safeSimpleDate(year, month, date) {
  var dateObject = new Date(year, month, date);
  return new _SimpleDate.SimpleDate(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate());
};
/**
 * @param {Number} year What year is it!?
 * @param {Number} month 0 for Jan, 1 for Feb, etc., à la Date
 * @param {Number} weekStartDay 0 for Sunday, 1 for Monday
 * @returns An array of arrays, where each array is a row of the calendar
 */


var computeWeeksOfMonth = function computeWeeksOfMonth(year, month, weekStartDay) {
  // Per the Date API convention, "date" = day of month, "day" = day of week.
  var monthStartDay = new Date(year, month).getDay();
  var monthEndDate = new Date(year, month + 1, 0).getDate();
  var weekEndDay = (weekStartDay + 6) % 7;
  var weeks = [[]]; // Get trailing dates from the previous month

  var startOffset = (monthStartDay - weekStartDay + 7) % 7 - 1;
  var prevMonthEndDate = new Date(year, month, 0).getDate();

  for (var date = prevMonthEndDate - startOffset; date <= prevMonthEndDate; date++) {
    weeks[0].push(safeSimpleDate(year, month - 1, date));
  }

  var week = 0;
  var day = monthStartDay;

  for (var _date = 1; _date <= monthEndDate; _date++) {
    weeks[week].push(safeSimpleDate(year, month, _date));

    if (day === weekEndDay) {
      week++;
      weeks.push([]);
    }

    day = (day + 1) % 7;
  } // Add leading dates for the next month until we have a full 6 weeks


  var endOffset = 7 * (6 - weeks.length) + 7 - weeks[week].length;

  for (var _date2 = 1; _date2 <= endOffset; _date2++) {
    weeks[week].push(safeSimpleDate(year, month + 1, _date2));

    if (day === weekEndDay && _date2 !== monthEndDate) {
      week++;
      weeks.push([]);
    }

    day = (day + 1) % 7;
  }

  return weeks;
};

var getDateForElement = function getDateForElement(element) {
  return new _SimpleDate.SimpleDate(+element.getAttribute('data-year'), +element.getAttribute('data-month'), +element.getAttribute('data-date'));
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Month__Wrapper",
  componentId: "m03geq-0"
})(_templateObject());

var Header = _styledComponents.default.div.withConfig({
  displayName: "Month__Header",
  componentId: "m03geq-1"
})(_templateObject2());

var Heading = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "Month__Heading",
  componentId: "m03geq-2"
})(_templateObject3());

var Table = _styledComponents.default.table.withConfig({
  displayName: "Month__Table",
  componentId: "m03geq-3"
})(_templateObject4());

var WeekdayHeading = _styledComponents.default.th.withConfig({
  displayName: "Month__WeekdayHeading",
  componentId: "m03geq-4"
})(_templateObject5(), _colors.SLINKY, _Styles.FONT_FAMILIES.medium);

var todayDotMixin = (0, _styledComponents.css)(_templateObject6());
var disabledMixin = (0, _styledComponents.css)(_templateObject7());

var Day = _styledComponents.default.td.withConfig({
  displayName: "Month__Day",
  componentId: "m03geq-5"
})(_templateObject8(), function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? 'not-allowed' : 'pointer';
}, function (_ref2) {
  var isDisabled = _ref2.isDisabled,
      isSelected = _ref2.isSelected,
      isToday = _ref2.isToday,
      isCurrentMonth = _ref2.isCurrentMonth;
  if (isSelected) return _colors.OLAF;
  if (isDisabled || !isCurrentMonth) return _colors.BATTLESHIP;
  if (isToday) return _colors.SORBET_DARK;
  return null;
}, function (_ref3) {
  var isDisabled = _ref3.isDisabled,
      isSelected = _ref3.isSelected;
  if (isDisabled) return null;
  if (isSelected) return _colors.CALYPSO;
  return null;
}, (0, _Styles.setBorderRadius)(), function (_ref4) {
  var isSelected = _ref4.isSelected,
      isToday = _ref4.isToday;
  return isSelected || isToday ? _Styles.FONT_FAMILIES.demibold : _Styles.FONT_FAMILIES.medium;
}, function (_ref5) {
  var isToday = _ref5.isToday;
  return isToday && todayDotMixin;
}, function (_ref6) {
  var isDisabled = _ref6.isDisabled;
  return isDisabled && disabledMixin;
}, function (_ref7) {
  var isDisabled = _ref7.isDisabled,
      isSelected = _ref7.isSelected;
  return !isDisabled && !isSelected && _colors.CALYPSO_LIGHT;
});

var Month =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Month, _PureComponent);

  function Month() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Month);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Month)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (evt) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value;
      var dateEl = evt.currentTarget;
      var newValue = getDateForElement(dateEl);
      if ((0, _SimpleDate.equals)(value, newValue)) return;
      onChange((0, _SyntheticEvent.default)(newValue));
    };

    return _this;
  }

  (0, _createClass2.default)(Month, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          disabledValues = _this$props2.disabledValues,
          focusedValue = _this$props2.focusedValue,
          leftControl = _this$props2.leftControl,
          max = _this$props2.max,
          maxValidationMessage = _this$props2.maxValidationMessage,
          min = _this$props2.min,
          minValidationMessage = _this$props2.minValidationMessage,
          month = _this$props2.month,
          monthNames = _this$props2.monthNames,
          __onChange = _this$props2.onChange,
          ownerId = _this$props2.ownerId,
          rightControl = _this$props2.rightControl,
          today = _this$props2.today,
          value = _this$props2.value,
          weekdayHeadings = _this$props2.weekdayHeadings,
          weekStartDay = _this$props2.weekStartDay,
          year = _this$props2.year,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["disabledValues", "focusedValue", "leftControl", "max", "maxValidationMessage", "min", "minValidationMessage", "month", "monthNames", "onChange", "ownerId", "rightControl", "today", "value", "weekdayHeadings", "weekStartDay", "year"]);
      return _react.default.createElement(Wrapper, rest, _react.default.createElement(Header, null, leftControl, _react.default.createElement(Heading, {
        "aria-hidden": true
      }, monthNames[month], " ", year), rightControl), _react.default.createElement(Table, {
        role: "presentation"
      }, _react.default.createElement("thead", {
        "aria-hidden": true
      }, _react.default.createElement("tr", null, rotateArrayBy(weekdayHeadings, weekStartDay).map(function (weekdayHeading, i) {
        return _react.default.createElement(WeekdayHeading, {
          key: i
        }, weekdayHeading);
      }))), _react.default.createElement("tbody", null, computeWeeksOfMonth(year, month, weekStartDay).map(function (week, i) {
        return _react.default.createElement("tr", {
          key: i
        }, week.map(function (simpleDate, j) {
          if (typeof simpleDate === 'number') return _react.default.createElement("td", {
            key: j,
            colSpan: simpleDate
          });
          var lessThanMin = min && (0, _SimpleDate.compare)(simpleDate, min) === -1;
          var moreThanMax = max && (0, _SimpleDate.compare)(simpleDate, max) === 1;
          var inDisabledValues = disabledValues && disabledValues.some(function (disabledValue) {
            return (0, _SimpleDate.equals)(simpleDate, disabledValue);
          });
          var isDisabled = lessThanMin || moreThanMax || inDisabledValues;
          var isFocused = (0, _SimpleDate.equals)(simpleDate, focusedValue);
          var isSelected = (0, _SimpleDate.equals)(simpleDate, value);
          return _react.default.createElement(_UITooltip.default, {
            "aria-live": "assertive",
            key: j,
            open: isFocused || undefined,
            title: (0, _lazyEval.default)(lessThanMin && minValidationMessage || moreThanMax && maxValidationMessage)
          }, _react.default.createElement(Day, {
            id: ownerId + "-" + simpleDate.month + "-" + simpleDate.date,
            "data-date": simpleDate.date,
            "data-month": simpleDate.month,
            "data-year": simpleDate.year,
            role: "menuitem",
            onClick: isDisabled ? undefined : _this2.handleClick,
            isDisabled: isDisabled,
            isSelected: isSelected,
            isCurrentMonth: simpleDate.month === month,
            isToday: (0, _SimpleDate.equals)(simpleDate, today)
          }, simpleDate.date));
        }));
      }))));
    }
  }]);
  return Month;
}(_react.PureComponent);

if (process.env.NODE_ENV !== 'production') {
  Month.propTypes = {
    disabledValues: _propTypes.default.array,
    focusedValue: _SimpleDateTypes.SimpleDateType,
    leftControl: _propTypes.default.node,
    max: _SimpleDateTypes.SimpleDateType,
    maxValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
    min: _SimpleDateTypes.SimpleDateType,
    minValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
    month: _propTypes.default.number.isRequired,
    monthNames: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
    onChange: _propTypes.default.func.isRequired,
    ownerId: _propTypes.default.string.isRequired,
    rightControl: _propTypes.default.node,
    today: _SimpleDateTypes.SimpleDateType.isRequired,
    value: _SimpleDateTypes.SimpleDateType,
    weekdayHeadings: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
    weekStartDay: _propTypes.default.number.isRequired,
    year: _propTypes.default.number.isRequired
  };
}

var _default = Month;
exports.default = _default;
module.exports = exports.default;